<template>
  <side-bar-page>
    <template slot="content">
      <div class="content content-m">
        <div class="content-fluid">
          <div class="row" v-if="!getUserProfile.isSocialRegister">
            <div class="col-md-4"></div>
            <div class="col-md-4 mobile-container">
              <div class="card margin">
                <div class="card-header">
                  <h4 class="title title-header">
                    {{$t('s_change_password')}}
                  </h4>
                </div>
                <div class="card-body">                  
                  <form action="javascript:void(0);" v-on:submit="saveNewPassword()">
                    <div class="form-group">
                      <label for="oldPassword">{{$t('s_old_password')}}</label>
                      <input type="password" class="form-control" v-model="oldPassword" id="oldPassword" :placeholder="$t('s_old_password_ph')">
                    </div>
                    <div class="form-group">
                      <label for="newPassword">{{$t('s_new_password')}}</label>
                      <input type="password" class="form-control" v-model="newPassword" id="newPassword" :placeholder="$t('s_new_password_ph')">
                    </div>
                    <div class="form-group">
                      <label for="newPassword2">{{$t('passwordConfirmation')}}</label>
                      <input type="password" class="form-control" v-model="newPassword2" id="newPassword2" :placeholder="$t('s_new_password_ph2')">
                    </div>
                    <button class="btn btn-outline-danger btn-filter btn-filter-i" type="submit">
                      {{$t('pr_new_password')}}
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-md-4"></div>
          </div>

          <div class="row" v-if="getUserProfile.isSocialRegister">
            <div class="col-md-4"></div>
            <div class="col-md-4 mobile-container">
              <h4 class="no-password">{{$t('s_password_err')}}</h4>
            </div>
            <div class="col-md-4"></div>
          </div>

        </div>
      </div>
    </template>
  </side-bar-page>
</template>

<script>
  import SideBarPage from '../components/SideBarPage';
  import syncLoader from 'vue-spinner/src/PulseLoader.vue';
  import swal from 'sweetalert2';
  import { mapActions, mapGetters} from 'vuex';
  import { USER_REQUEST, USER_CHANGE_PASSWORD, AUTH_LOGOUT } from "../store/actions/userConst";
  
  export default {
    created() {
      this.$store.dispatch(USER_REQUEST)
      .then((resp)=>console.log(resp))
      .catch((err)=>console.log(err));
    },
    data: function () {
      return  {
        oldPassword: null,
        newPassword: null,
        newPassword2: null,
      }
    },
    computed: {
      ...mapGetters(['getUserProfile', 'currentLng']),
    },
    methods: {
      ...mapActions([USER_CHANGE_PASSWORD, AUTH_LOGOUT]),
      saveNewPassword() {
        if (this.newPassword === this.newPassword2) {
          this.USER_CHANGE_PASSWORD({
            oldPassword: this.oldPassword,
            newPassword: this.newPassword
          })
          .then(() => {
            swal({
              type: 'success',
              text: this.$t('text25'),
              keydownListenerCapture: true,
              allowOutsideClick: false
            })
            .then(() => {
              this.oldPassword = null;
              this.newPassword = null;
              this.$router.push({name: 'profile', params: {id: this.getUserProfile.id}})
            })
          })
          .catch(err => {
            const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
            switch (code) {
              case 'INVALID_PASSWORD':
                swal({
                  type: 'error',
                  text: this.$t('text26'),
                  keydownListenerCapture: true,
                  allowOutsideClick: false
                });
                break;
              case 'SIMPLE_PASSWORD':
                swal({
                  type: 'error',
                  text: this.$t('r_password'),
                  keydownListenerCapture: true,
                  allowOutsideClick: false
                });
                break;
              default:
                swal({
                  type: 'error',
                  text: this.$t('text16'),
                  keydownListenerCapture: true,
                  allowOutsideClick: false
                });
                break
            }
          });
        } else {
          swal({
            type: 'error',
            text: this.$t('text20')+'!',
            keydownListenerCapture: true,
            allowOutsideClick: false
          }).then(() => {
              this.oldPassword = null;
              this.newPassword = null;
              this.newPassword2 = null;
          });
        }
      },
    },
    components: { SideBarPage, syncLoader }
  }
</script>

<style scoped>
  .card {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: .25rem
  }
  .card .card-header {
    padding: 15px 15px 0;
    background-color: #fff;
    border-bottom: none!important;
  }
  .card-header {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(255, 255, 255, 0.03);
    border-bottom: 1px solid rgba(255, 255, 255, 0.125);
  }
  .card.margin {
    margin-top: 25%;
  }
  h4 {
    font-size: 1.4rem;
  }
  .card label {
    font-size: 14px;
    margin-bottom: 5px;
    text-transform: uppercase;
    font-weight: 400;
    color: #828080;
  }
  label {
    display: inline-block;
  }
  .title {
    color: #565656;
  }
  .content {
    padding-top: 25px !important;
    background-color: #F7F7F8 !important;
    min-height: 100%;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .v-input__control {
    width: 100%;
  }
  .form-radio {
    font-size: 22px !important;
  }
  .form-radio span {
    font-size: 14px !important;
    padding-left: 5px;
    margin-bottom: 5px;
  }
  .form-control::-webkit-input-placeholder {
    color: #6c757d;
    opacity: 1
  }

  .form-control:-ms-input-placeholder,
  .form-control::-ms-input-placeholder {
      color: #6c757d;
      opacity: 1
  }

  .form-control::placeholder {
      color: #6c757d;
      opacity: 1
  }

  .un-date-picker .un-input .un-input-inside:-moz-placeholder,
  .un-date-picker .un-input .un-input-inside::-moz-placeholder,
  .form-control:-moz-placeholder,
  .form-control::-moz-placeholder,
  .form-group .un-input-inside:-moz-placeholder,
  .form-group .un-input-inside::-moz-placeholder {
      color: #ddd;
      opacity: 1;
      filter: alpha(opacity=100)
  }

  .un-date-picker .un-input .un-input-inside::-webkit-input-placeholder,
  .form-control::-webkit-input-placeholder,
  .form-group .un-input-inside::-webkit-input-placeholder {
      color: rgb(207, 207, 207);
      opacity: 1;
      filter: alpha(opacity=100)
  }

  .un-date-picker .un-input .un-input-inside:-ms-input-placeholder,
  .form-control:-ms-input-placeholder,
  .form-group .un-input-inside:-ms-input-placeholder {
      color: #ddd;
      opacity: 1;
      filter: alpha(opacity=100)
  }

  .form-control:focus {
    border-color: rgba(0, 123, 255, 0.7) !important;
  }

  .form-control {
    background-color: #fff;
    border-radius: 4px;
    font-size: .975rem;
    color: #565656;
    padding: 8px 12px;
    height: 40px;
    box-shadow: none;
  }

  .form-control:disabled, {
    background-color: #e9ecef !important;
    opacity: 1;
  }
  .card-body.b-1 {
    box-shadow: inset 0 7px 10px -7px rgba(0,0,0,.14);
    min-height: 100px !important;
  }
  .btn-order {
    width: 100%;
    font-weight: bold;
    color: white;
    background-color: #ffc439 !important;
    text-shadow: rgba(0, 0, 0, 0.72) 1px 1px 1px;
    height: 45px !important;
    font-size: 1.05rem;
    text-transform: uppercase;
  }
  .btn-order:hover {
    color: white !important;
    background-color: #ffca4e !important;
    text-shadow: rgba(0, 0, 0, 0.72) 1px 1px 1px;
  }
  .card-block {
    text-align: center;
    vertical-align: middle;
    display: inherit;
  }
  .no-password {
    text-align: center;
    color: red;
    text-transform: uppercase;
    font-weight: 600;
    margin-top: 25%;
  }
  .btn-filter-i {
    margin-top: 5px;
    height: 40px !important;
  }
  @media only screen and (max-width: 768px) {
    .no-password {
      margin-top: 0;
    }
    .card.margin {
      margin-top: 0;
    }
  }
</style>
